import { render, staticRenderFns } from "./PassengersPopup.vue?vue&type=template&id=18b9ae78&"
import script from "./PassengersPopup.vue?vue&type=script&lang=js&"
export * from "./PassengersPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports